
import React from "react";
import { Card } from "../components/ui/card";

const watchData = [
  {
    name: "Pet Mix",
    pricePerKg: 5000,
    priceLapak: 4500,
    // image: "https://via.placeholder.com/100x100?text=Pet+Mix",
  },
  {
    name: "Pet Clear / Bening",
    pricePerKg: 3000,
    priceLapak: 2500,
    // image: "https://via.placeholder.com/100x100?text=Pet+Clear+Bening",
  },
  {
    name: "Pet BM ( Biru Muda )",
    pricePerKg: 7000,
    priceLapak: 6500,
    // image: "https://via.placeholder.com/100x100?text=Pet+BM+Biru+Muda",
  },
  {
    name: "Pet Warna",
    pricePerKg: 2300,
    priceLapak: 2500,
    image: null,
  },
  {
    name: "Pet PK",
    pricePerKg: 3000,
    priceLapak: 3100,
    image: null,
  },
  {
    name: "Pet Galon",
    pricePerKg: 3300,
    priceLapak: 3500,
    image: null,
  },
  {
    name: "Gelasan A",
    pricePerKg: 4000,
    priceLapak: 4100,
    image: null,
  },
  {
    name: "Tutup",
    pricePerKg: 1500,
    priceLapak: 1600,
    image: null,
  },
];

const WatchPrice = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      {/* Hero Section */}
      <section className="w-full flex flex-col items-center justify-center pt-24 pb-8">
        <div className="max-w-4xl mx-auto">
          <h1
            className="text-4xl md:text-5xl font-bold text-center mb-4"
            style={{ color: "rgb(0, 55, 32)", letterSpacing: "-0.02em" }}
          >
            Watch Price by Kilogram
          </h1>
          <p
            className="text-lg text-gray-500 text-center mb-8"
            style={{ maxWidth: "700px", margin: "0 auto" }}
          >
            Displaying watch prices based on their weight in kilograms.
          </p>
        </div>
      </section>

      {/* Card Section */}
      <section className="w-full flex flex-col items-center justify-center">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {watchData.map((watch, idx) => (
            <Card
              key={watch.name}
              className="product-card group"
              style={{
                background:
                  "linear-gradient(180deg, #ffffff 0%, #f7faf9 100%)",
                border: "1px solid rgba(0, 0, 0, 0.05)",
                borderRadius: "16px",
                padding: "2.5rem 2rem",
                transition: "all 0.35s ease",
                cursor: "pointer",
                boxShadow:
                  "0 5px 15px rgba(0, 0, 0, 0.05), 0 0 10px rgba(0, 55, 32, 0.05)",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "280px",
              }}
              onMouseEnter={e => (e.currentTarget.style.transform = "translateY(-6px)")}
              onMouseLeave={e => (e.currentTarget.style.transform = "translateY(0)")}
            >
              {watch.image ? (
                <div
                  style={{
                    width: "110px",
                    height: "110px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    marginBottom: "1.5rem",
                    border: "3px solid rgba(0, 55, 32, 0.1)",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <img
                    src={watch.image}
                    alt={watch.name}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={e => {
                      e.target.src = "https://via.placeholder.com/100x100?text=No+Image";
                    }}
                  />
                </div>
              ) : null}
              <h3
                style={{
                  fontWeight: 700,
                  fontSize: "1.25rem",
                  lineHeight: 1.3,
                  marginBottom: "0.75rem",
                  color: "rgb(0, 55, 32)",
                }}
              >
                {watch.name}
              </h3>
              <p style={{ fontSize: "0.95rem", color: "rgb(87, 99, 93)", margin: 0, lineHeight: 1.6 }}>
                Harga per Kg: Rp{watch.pricePerKg.toLocaleString("id-ID")},00
              </p>
              <p style={{ fontSize: "0.95rem", color: "rgb(87, 99, 93)", margin: 0, lineHeight: 1.6 }}>
                Harga Lapak: Rp{watch.priceLapak.toLocaleString("id-ID")},00
              </p>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

export default WatchPrice;
